import 'whatwg-fetch';
import React, { useEffect, useState } from 'react';
import Card from './Card';
import PropTypes from 'prop-types';
import { Loading } from 'carbon-components-react';
import { useWindowSize } from '../hooks/useWindowSize';
import './Widget.scss';

function Widget({ element }) {
  async function fetchData() {
    let response;

    try {
      response = await window.fetch(
        `https://www.trustradius.com/api/v2/tqw/${trid}`,
      );

      return await response.json();
    } catch (e) {
      console.error(e);
      setStatus('error');
    }
  }
  const windowWidth = useWindowSize().width;
  const [palette] = useState(element.getAttribute('data-trust-radius-palette'));
  const [googlestars] = useState(
    element.getAttribute('data-trust-radius-google-stars'),
  );
  const [trid] = useState(element.getAttribute('data-trust-radius-id'));
  const [status, setStatus] = useState('loading');
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchData().then(data => {
      setData(data);
      setStatus('ready');
    });
  }, []);

  return (
    <div className="trust-radius-widget">
      <div className={`Widget Widget-${palette}`}>
        <div className="Widget-wrapper">
          {status === 'loading' && (
            <div className="Widget-message">
              <Loading withOverlay={false} />
            </div>
          )}
          {status === 'ready' && (
            <Card
              data={data}
              palette={palette}
              width={windowWidth}
              stars={googlestars}
              theme={palette}
              trid={trid}
            />
          )}
          {status === 'error' && (
            <div className="Widget-message">
              <p>
                The was a problem loading Trust Radius reviews. Please try again
                later.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

Widget.propTypes = {
  element: PropTypes.instanceOf(Element),
};

export default Widget;
